import { Injectable } from '@angular/core';
import { IncidentServiceBase } from '../services/incident-base.service';
import { FraudAamvaModel } from '../models/fraud-aamva.model';

@Injectable()
export class FraudAamvaIncidentService extends IncidentServiceBase<FraudAamvaModel> {
    constructor() {
        super('FraudAamva', () => new FraudAamvaModel());
    }

    public getFraudDocuments(incidentNumberId: number) {
        return this.get('Incident/' + incidentNumberId + '/Fraud/Documents');
    }
}
